const INITIAL_STATE = {
  orders: [],
  ordersApi: [],
  orderTrackingResult: null,
  banners: [],
  campaigns: [],
  orderObj: null,
};

const setOrderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_ORDER_OBJECT":
      return { ...state, orders: [...state.orders, action.payload] };
    // case "ADD_TO_ORDERS_API":
    // eta joruri na jehetu ami oi page te gelei call korbo getallordersapi
    //   return { ...state, ordersApi: [...state.ordersApi, action.payload] };
    case "UPDATE_ORDERS_API":
      return { ...state, ordersApi: action.payload };

    case "UPDATE_SINGLE_ORDER_API":
      return {
        ...state,
        ordersApi: state.ordersApi.map((order) => {
          if (order.orderId == action.payload.orderId) {
            return { ...action.payload, paymentStatus: "pending" };
          } else {
            return order;
          }
        }),
      };
    case "UPLOAD_REFUND_APPLY":
      let orders = state.ordersApi.map((order) => {
        if (order.orderId == action.payload.orderId) {
          return action.payload;
        } else {
          return order;
        }
      });
      return { ...state, ordersApi: orders };
    case "GET_SINGLE_ORDER_API":
      return { ...state, orderObj: action.payload };
    case "GET_ALL_ORDERS_API_OF_SINGLE_USER":
      return { ...state, ordersApi: action.payload };
    case "GET_ORDER_TRACKING_RESULT":
      return { ...state, orderTrackingResult: action.payload };
    case "GET_ALL_BANNERS":
      return {
        ...state,
        banners: action.payload,
      };
    case "GET_ALL_CAMPAIGNS":
      return {
        ...state,
        campaigns: action.payload,
      };
    default:
      return { ...state };
  }
};
export default setOrderReducer;
